import React, { useState } from 'react';

const Navigation = ({
    FilterButtonData,
    FilterButtonFunction,
    ActiveTab,
    children,
}) => {
    const handleNavigationTabClick = (clickedTab) => {
        FilterButtonFunction(clickedTab);
    };
    return (
        <>
            <div className="navigation_wrapper">
                {FilterButtonData.map((navigationTab) => (
                    <button
                        className={
                            ActiveTab === navigationTab.navigation_tab_name
                                ? 'navigation_btn active'
                                : 'navigation_btn'
                        }
                        key={navigationTab.id}
                        id={navigationTab.navigation_tab_name}
                        onClick={() =>
                            handleNavigationTabClick(
                                navigationTab.navigation_tab_name
                            )
                        }
                    >
                        {navigationTab.navigation_tab_name}
                    </button>
                ))}
            </div>
            {children}
        </>
    );
};

export default Navigation;
